require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-elizabeth-scutchfield.json") })
        }
      }, "path---blog-author-elizabeth-scutchfield");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-elizabeth-scutchfield!./.cache/json/blog-author-elizabeth-scutchfield.json
// module id = 633
// module chunks = 231608221292675